import React from "react";
import "./index.css";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import SvgImage from "../../../Icons/Icons";
function DetailsCard(props) {
  const {
    key1,
    key2,
    key3,
    key4,
    key5,
    key6,
    value1,
    value2,
    value3,
    value4,
    value5,
    value6,
    userId,
    fleetId,
    itemTemp
  } = props;
  let x = value1?.length > 21;
  const navigate = useNavigate();

  if (x) {
    let p = value1?.split(",");
    x =
      (p[0] + (p?.length > 1 ? p[1] : ""))?.length > 21
        ? p[0]
        : p[0] + (p?.length > 1 ? p[1] : "");
  } else x = value1;

  let y = value2?.length > 21;
  if (y) {
    let p = value2?.split(",");
    y =
      (p[0] + (p?.length > 1 ? p[1] : ""))?.length > 21
        ? p[0]
        : p[0] + (p?.length > 1 ? p[1] : "");
  } else y = value2;
  return (
    <div className="card-12 expenseCard2">
      <div className="keys">
        <div className="text2 Regular normalGrey">{key1}</div>
        <div className="text2 Regular normalGrey">{key2}</div>
        <div className="text2 Regular normalGrey">{key3}</div>
        <div className="text2 Regular normalGrey">{key4}</div>
        <div className="text2 Regular normalGrey">{key5}</div>
        <div className="text2 Regular normalGrey">{key6}</div>
      </div>
      <div className="values">
        <Tooltip title={value1}>
          <div className="text2 Regular normalGrey">{x}</div>
        </Tooltip>
        <Tooltip title={value2}>
          <div className="text2 Regular normalGrey">{y}</div>
        </Tooltip>
        {key3 == "Driver" && userId ? (
          <div
            className="text2 Regular normalGrey"
            style={{
              cursor: "pointer",
              textDecorationLine: "underline",
              color: "blue",
            }}
            onClick={(e) => {
              navigate(`/DriversV2/${userId}?search=${value3}&offset=0`);
            }}
          >
            {value3}
          </div>
        ) : (
          <div className="text2 Regular normalGrey">{value3}</div>
        )}
        {key4 == "Vehicle" && fleetId ? (
          <div className=" d-flex">
          <div
            className="text2 Regular normalGrey"
            style={{
              cursor: itemTemp?.Fleet?.isRegular == "0" ? "" : "pointer",
              textDecorationLine: itemTemp?.Fleet?.isRegular == "0" ? "" : "underline",
              color: itemTemp?.Fleet?.isRegular == "0" ? "" : "blue",
            }}
            onClick={(e) => {
              if(itemTemp?.Fleet?.isRegular != "0") navigate(`/VehiclesV2/${fleetId}?search=${value4}&offset=0`);
            }}
          >
            {value4}
          </div>
                      {props?.isGPS ? <div onClick={() => {
                        navigate(`/GPS/${value4}?search=${value4}&offset=0`)
                      }}><SvgImage name = "gpsLogo"/></div> : <></>}</div>
        ) : (
          <div className="text2 Regular normalGrey">{value4}</div>
        )}
        <div className="text2 Regular normalGrey">{value5}</div>
        <div className="text2 Regular normalGrey">{value6}</div>
      </div>
      {/* <div>hello</div> */}
    </div>
  );
}

export default DetailsCard;
